<template>
  <li class="dropdown user user-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
      <img v-if="profileimg !== ''" :src="profileimg" class="img-employee user-image">
      <img v-if="profileimg === ''" src="~static/images/employee/no_image.png" class="img-employee user-image">
      <span class="hidden-xs">
        {{ currentUser.username[nowLang] }}
      </span>
    </a>
    <ul class="dropdown-menu">
      <li class="user-header">
        <template v-if="$router.match('profileimg').name !== '404'">
          <router-link :to="{ name: 'profileimg' }" class="profileimg">
            <img v-if="profileimg !== ''" :src="profileimg" class="img-employee img-circle">
            <img v-if="profileimg === ''" src="~static/images/employee/no_image.png" class="img-employee img-circle">
            <div class="profile-edit img-circle"><i class="fa fa-camera"></i> <div class="text">Change</div></div>
          </router-link>
        </template>
        <template v-else>
          <img v-if="profileimg !== ''" :src="profileimg" class="img-employee img-circle">
          <img v-if="profileimg === ''" src="~static/images/employee/no_image.png" class="img-employee img-circle">
        </template>
        <p>
          {{ currentUser.p_coduser }} : {{ currentUser.username[nowLang] }}
          <small>{{ currentUser.company[nowLang] }}</small>
          <small>{{ currentUser.position[nowLang] }}</small>
        </p>
      </li>
      <li class="user-footer">
        <template v-if="version >= '2.0.0'">
          <div class="pull-left">
            <router-link :to="{ name: 'hres31x' }" class="btn btn-default btn-flat">
              Profile
            </router-link>
          </div>
        </template>
        <div class="pull-right">
          <a @click="postLogout()" class="btn btn-default btn-flat">Logout</a>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'header-user',
  props: [ 'currentUser', 'nowLang', 'version', 'postLogout', 'profileimg' ]
}
</script>


// WEBPACK FOOTER //
// HeaderUser.vue?1d97a27b